export const RegionActionTypes = {
  GET_REGION_PENDING: "GET_REGION_PENDING",
  GET_REGION_SUCCESS: "GET_REGION_SUCCESS",
  GET_REGION_ERROR: "GET_REGION_ERROR",
};
